import REPORT from './reports';

const deadlineOption = {
  label: 'Due Date',
  value: 'deadline',
};

const projectTitleOption = {
  label: 'Project Title',
  value: 'description',
};

const clientOption = {
  label: 'Client',
  value: 'clients.name',
};

const funderOption = {
  label: 'Funder',
  value: 'funders.name',
};

export const REPORTS = [
  {
    title: 'Current Awards',
    value: 'client_awards',
    type: 'client',
    isMulti: true,
    ReportContent: REPORT.client.CurrentAwards,
    active: true,
    sortOptions: [
      projectTitleOption,
      {
        label: 'Project Start Date',
        value: 'award_start',
      },
      {
        label: 'Project End Date',
        value: 'award_end',
      },
      clientOption,
      {
        label: 'Award Amount',
        value: 'amount_awarded',
      },
      funderOption,
    ],
    description:
      'The Current Awards Report pulls a detailed summary of all projects with the status of Awarded during the specified time period. The report includes total projects, aggregate award sum and total hours spent on awarded projects. The date range field pulls from projects award start and end date.',
  },
  {
    title: 'Upcoming Project Report',
    value: 'upcoming_projects',
    type: 'client',
    isMulti: true,
    ReportContent: REPORT.client.UpcomingProjects,
    active: true,
    sortOptions: [projectTitleOption, deadlineOption, clientOption],
    description:
      'The Upcoming Projects Report is a snapshot of upcoming projects and all actions associated with that project. The date range field pulls from the projects deadline field.',
  },
  {
    title: 'Client Summary Report',
    value: 'client_report',
    type: 'client',
    isMulti: true,
    ReportContent: REPORT.client.Summary,
    active: true,
    sortOptions: [
      projectTitleOption,
      deadlineOption,
      clientOption,
      {
        label: 'Status',
        value: 'status',
      },
      funderOption,
    ],
    description:
      'The Client Summary Report is a snapshot of all activity for a certain range of dates. This report pulls client Projects (no matter the status) based on the deadline date of the project(s).This report shows the total number of projects and their statuses in the date range chosen. The first page of the report is an overview of total number of projects and any statuses. The date range fields pull from projects deadline field associated to the  client(s) selected.',
  },
  {
    title: 'Funders Report',
    value: 'funder_report',
    type: 'funder',
    ReportContent: REPORT.funder.Summary,
    active: true,
    sortOptions: [funderOption],
    description:
      'The Funders Report displays information about the funder as well as all associated projects with a due date within the date range chosen. The date range fields pull from projects deadline field associated to the client(s) selected.',
  },
  {
    title: 'Opportunity Review',
    value: 'opportunity_review',
    type: 'project',
    ReportContent: REPORT.project.OpportunityReview,
    active: true,
    sortOptions: [
      {
        label: 'Action Items Deadline',
        value: 'actions.deadline',
      },
    ],
    noDate: true,
    description:
      'The Opportunity Review pulls all the information pertaining to a single project. It includes the general project information, funder information, and action items',
  },
  {
    title: 'Deadlines Report',
    value: 'deadlines_report',
    type: 'client',
    isMulti: true,
    ReportContent: REPORT.client.DeadlinesReport,
    active: true,
    sortOptions: [
      deadlineOption,
      {
        label: 'Client',
        value: 'clientName',
      },
      {
        label: 'Assignee',
        value: 'assigneeName',
      },
      projectTitleOption,
    ],
    description:
      'The Deadlines report pulls a list of all deadlines, regardless of status, for the given time period',
  },
];

export const ACTIVE_REPORTS = REPORTS.filter(({ active }) => active);
export const REPORT_LIST = ACTIVE_REPORTS.map(({ value }) => value);
export const NEEDS_DATES = ACTIVE_REPORTS.filter(({ noDate }) => !noDate).map(
  ({ value }) => value,
);

export const DIRECTION_OPTIONS = [
  {
    label: 'Ascending',
    value: 'asc',
  },
  {
    label: 'Descending',
    value: 'desc',
  },
];

export const REPORT_OPTIONS = ACTIVE_REPORTS.map(
  ({ title, value, description, sortOptions }) => ({
    label: title,
    value,
    description,
    sortOptions,
  }),
);

const BASE_DATE_OPTIONS = [
  {
    value: 'this_year',
    label: 'This Year',
  },
  {
    value: 'this_month',
    label: 'This Month',
  },
  {
    value: 'custom_dates',
    label: 'Custom Dates',
  },
];

export const DATE_OPTIONS = [
  {
    value: 'last_year',
    label: 'Last Year',
  },
  {
    value: 'last_month',
    label: 'Last Month',
  },
  ...BASE_DATE_OPTIONS,
];

export const UPCOMING_DATE_OPTIONS = [
  {
    value: 'next_year',
    label: 'Next Year',
  },
  {
    value: 'next_quarter',
    label: 'Next Quarter',
  },
  {
    value: 'next_month',
    label: 'Next Month',
  },
  ...BASE_DATE_OPTIONS,
];
